import apiClient from '../../../api/apiClient';

export const fetchLeadStatuses = async () => {
  try {
        const response = await apiClient.get('/statuses');
    return response.data;
  } catch (error) {
    console.error("Error fetching lead statuses:", error);
    return [];
  }
};